// extracted by mini-css-extract-plugin
export var arrowForButton = "index-module--arrow-for-button--fR+vu";
export var backgroundImageStarted = "index-module--background-image-started--hP8i2";
export var button = "index-module--button--TkACv";
export var buttonWrapper = "index-module--button-wrapper--eGd6U";
export var contentWrapper = "index-module--content-wrapper--scgNT";
export var getStartedSectionWrapper = "index-module--get-started-section-wrapper--5HOWt";
export var text = "index-module--text--VGh-u";
export var title = "index-module--title--Z4oKG";